module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Light.a6f3d6ba.otf";